import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationService } from '../services/auth.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ManagedInstructionsGuard {

  constructor(private router: Router, private cookie: CookieService, private authenticationService: AuthenticationService) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.currentUser();
    if (route.queryParams['x-token']) {
      const token = route.queryParams['x-token'];
      const expireDate = new Date();
      expireDate.setTime(expireDate.getTime() + 30 * 60 * 1000);
      this.cookie.set('x-token', token, expireDate, '/', '', false, "Lax");
      if (currentUser) {
        this.router.navigate(['/projects']);
        return false;
      }
      else {
        return true;
      }
    }
    else {
      if (currentUser) {
        this.router.navigate(['/projects']);
        return false;
      }
      else {
        this.router.navigate(['/account/login'], { queryParams: { returnUrl: state.url } });
      }
    }
    return false;
  }
};
